/**
 * Garage modal open/close.
 *
 * A native <dialog> via showModal(), so Escape, the top layer and focus
 * containment come from the browser. This only wires the triggers and the
 * backdrop click.
 *
 * Delegated from document so triggers rendered later — inside the garage
 * dropdown, for instance — work without re-binding.
 */
(function () {
  'use strict';

  function modal() {
    return document.querySelector('[data-garage-modal]');
  }

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-garage-modal-open]');
    if (opener) {
      event.preventDefault();
      const dialog = modal();
      if (!dialog) return;

      dialog.showModal();

      // A family tile on a brand page opens the modal narrowed to that make
      // and family; a plain opener leaves the finder as it was.
      if (opener.dataset.garageModalPreset) {
        try {
          const preset = JSON.parse(opener.dataset.garageModalPreset);
          const finder = dialog.querySelector('fitment-finder');
          if (finder && typeof finder.preset === 'function' && window.FitmentData?.options('type').length) {
            finder.preset(preset);
          } else if (finder) {
            finder.dataset.presetMake = preset.make || '';
            finder.dataset.presetType = preset.type || '';
            finder.dataset.presetModelPrefix = preset.modelPrefix || '';
          }
        } catch (err) {
          console.error('[garage-modal] bad preset', err);
        }
      }

      // Close whatever dropdown launched it, so it isn't left hanging open
      // behind the backdrop.
      opener.closest('[data-mega-item]')?.removeAttribute('data-open');
      opener.closest('[data-mega-item]')
        ?.querySelector('[data-mega-trigger]')?.setAttribute('aria-expanded', 'false');
      const panel = opener.closest('[data-mega-item]')?.querySelector('[data-mega-panel]');
      if (panel) panel.hidden = true;

      document.dispatchEvent(new CustomEvent('garage-modal:opened'));
      return;
    }

    if (event.target.closest('[data-garage-modal-close]')) {
      modal()?.close();
      return;
    }

    // Clicking the backdrop: the dialog element's own box covers only the
    // panel, so a click landing on the dialog itself is outside the content.
    const dialog = modal();
    if (dialog?.open && event.target === dialog) dialog.close();
  });

  /**
   * A machine chosen inside the modal is a search, not garage admin (Lucas,
   * 2026-10-13): the finder adds it to the garage and goes on to its parts
   * page, and nothing here cancels that. The dialog closes for the moment
   * the page takes to leave.
   */
  document.addEventListener('fitment:selected', (event) => {
    const dialog = modal();
    if (!dialog?.open || !dialog.contains(event.target)) return;
    dialog.close();
  });
})();
